import { render, staticRenderFns } from "./WatchdogEdit.vue?vue&type=template&id=229f3658&scoped=true&"
import script from "./WatchdogEdit.vue?vue&type=script&lang=js&"
export * from "./WatchdogEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f3658",
  null
  
)

export default component.exports